import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { GetRubsByClientName } from "../../../../api/User/ACG/ClientRubsApi";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import { useSelector } from "react-redux";
import Fontstyling from "../../../../components/common/comman";

const ClientRubs = ({navigate}) => {
  const clientId = useSelector((state) => state.clientData.value?.clientID);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const overrideColumn = [
    {
      title: "Client ID",
      field: "client_ID",
    },
    {
      title: "Risk Profile",
      field: "plan",
    },
    {
      title: "Enrollment Percentage",
      field: "enrollment_PCT",
    },
    {
      title: "Claim Percentage",
      field: "claim_PCT",
    },
    {
      title: "Est. Male Count",
      field: "est_M_CT",
    },
    {
      title: "Est. Female Count",
      field: "est_F_CT",
    },
    {
      title: "Est. Male Claim(s)",
      field: "est_M_Claim",
    },
    {
      title: "Est. Female Claim(s)",
      field: "est_F_Claim",
    },
    {
      title: "Est. Male Proj. Claim(s)",
      field: "est_M_ProjClaim",
    },
    {
      title: "Est. Female Proj. Claim(s)",
      field: "est_F_ProjClaim",
    },
  ];

  useEffect(() => {
    getData();
  }, [clientId]);

  const getData = () => {
    setIsLoading(true);
    GetRubsByClientName(clientId)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  return (
    <div>
      <CustomMaterialTable
        isExport={false}
        overrideColumn={overrideColumn}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        isLoading={isLoading}
      />
      {/* <div className="mt-5 d-flex justify-content-end">
      <button style={Fontstyling.addnewbutton} onClick={()=>navigate("/ACGHealthInsights/report&extract/rptexport")}>Go to Reports</button>
      </div> */}
    </div>
  );
};

export default ClientRubs;
